import { motion } from "framer-motion";

const GithubIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const contacts = [
  {
    Icon: EmailIcon,
    label: "Email",
    value: "veerabhadraswamyct66@gmail.com",
    href: "mailto:veerabhadraswamyct66@gmail.com",
    color: "from-sky-500 to-blue-600",
  },
  {
    Icon: WhatsAppIcon,
    label: "WhatsApp",
    value: "+91-7022604157",
    href: "https://wa.me/917022604157?text=Hi%20Veerabhadraswamy%2C%20I%20saw%20your%20portfolio%20and%20would%20like%20to%20connect!",
    color: "from-green-400 to-green-600",
  },
  {
    Icon: LinkedInIcon,
    label: "LinkedIn",
    value: "linkedin.com/in/veerabhadraswamy",
    href: "https://www.linkedin.com/in/veerabhadraswamy",
    color: "from-blue-500 to-indigo-600",
  },
  {
    Icon: GithubIcon,
    label: "GitHub",
    value: "github.com/veerabhadra50",
    href: "https://github.com/veerabhadra50",
    color: "from-slate-500 to-gray-700",
  },
  {
    Icon: PhoneIcon,
    label: "Phone",
    value: "+91-7022604157",
    href: "tel:+917022604157",
    color: "from-teal-500 to-cyan-600",
  },
  {
    Icon: LocationIcon,
    label: "Location",
    value: "Bengaluru, India",
    href: "https://maps.google.com/?q=Bengaluru,India",
    color: "from-red-500 to-rose-600",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-sky-400 font-semibold uppercase tracking-widest text-sm mb-2">Let's Connect</p>
          <h2 className="text-4xl md:text-5xl font-black text-white">Get In Touch</h2>
          <div className="w-16 h-1 bg-sky-500 mx-auto mt-4 rounded-full" />
          <p className="text-slate-400 mt-5 max-w-xl mx-auto text-sm leading-relaxed">
            Looking for a DevOps Engineer or cloud consultant? I'm open to freelance projects, full-time roles,
            and collaborations. Let's build something great together.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {contacts.map((c, i) => (
            <motion.a
              key={c.label}
              href={c.href}
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-[#0d1526] border border-sky-500/20 rounded-2xl p-5 flex items-center gap-4 card-hover group w-full min-w-0"
            >
              <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${c.color} flex items-center justify-center text-white shrink-0`}>
                <c.Icon />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-slate-400 text-xs font-semibold uppercase tracking-wider">{c.label}</p>
                <p className="text-white font-medium text-sm group-hover:text-sky-400 transition-colors truncate">
                  {c.value}
                </p>
              </div>
            </motion.a>
          ))}

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6 }}
            className="sm:col-span-2 bg-gradient-to-r from-sky-500/10 to-blue-600/10 border border-sky-500/20 rounded-2xl p-6 text-center"
          >
            <p className="text-white font-bold text-lg mb-2">Ready to work together?</p>
            <p className="text-slate-400 text-sm mb-5">
              Whether it's a freelance project or a full-time opportunity — I'm just one message away.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <a
                href="https://wa.me/917022604157?text=Hi%20Veerabhadraswamy%2C%20I%20saw%20your%20portfolio%20and%20would%20like%20to%20connect!"
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-44 bg-green-500 hover:bg-green-400 text-white font-bold px-6 py-3 rounded-full transition-all text-sm text-center flex items-center justify-center gap-2"
              >
                <WhatsAppIcon /> WhatsApp Me
              </a>
              <a
                href="mailto:veerabhadraswamyct66@gmail.com"
                className="w-full sm:w-44 bg-sky-500 hover:bg-sky-400 text-white font-bold px-6 py-3 rounded-full transition-all glow text-sm text-center flex items-center justify-center gap-2"
              >
                <EmailIcon /> Send Email
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
